/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @enum{number}
 */
export var ErrorCode;
(function (ErrorCode) {
 ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
 ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
 ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
})(ErrorCode = ErrorCode || (ErrorCode = {}));

//# sourceMappingURL=xhrio.js.map



//////////////////
// WEBPACK FOOTER
// ../storage/dist/esm/src/implementation/xhrio.js
// module id = null
// module chunks = 